import { render, staticRenderFns } from "./AddNew.vue?vue&type=template&id=7f0d399a&scoped=true"
import script from "./AddNew.vue?vue&type=script&lang=js"
export * from "./AddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0d399a",
  null
  
)

export default component.exports